<template>
  <div class="reward-distribution">
    <div class="banner">
      <img src="../../assets/images/winterGame/reward_banner.png">
    </div>
    <div class="reward-body">
      <div v-if="otherSeasonData.length > 0" class="switch-season">
        <slideDownSelect
          @change="seasonChange"
          :isSeason="false"
          :title="currentSeasonLabel"
          :slideData="otherSeasonData"
          :widthSty="true"
        />
      </div>
      <div class="reward-list" v-if="rewardList.length > 0 && !loading">
        <div class="reward-item" v-for="(item, index) in rewardList" :key="index">
          <div class="left-warp">
            <p class="reward-name">{{item.itemName}}</p>
            <p class="reward-time">{{item.itemDate}}</p>
          </div>
          <div class="right-wrap">{{ item.isPlus ? '+' : '' }}{{item.amount}}</div>
        </div>
      </div>
      <div class="empty-wrap" v-if="otherSeasonData.length == 0">
        <div class="empty-img"></div>
        <p class="empty-text">暂无奖励～</p>
      </div>
    </div>
  </div>
</template>

<script>
import {
  cupRewardSeason,
  cupRewardV2,
} from "../../api/winterGame";
import slideDownSelect from "./components/slideDownSelect.vue";
import { Toast } from "vant";
export default {
  data() {
    return {
      rewardList: [1, 2, 3],
      loading: false,
      finished: true,
      currentSeasonLabel: '',
      otherSeasonData: [],
      campusId: '',
      selectSeasonTagId: '',
    }
  },
  components: {
    slideDownSelect
  },
  async mounted() {
   const seasonData =  await this.queryCupRewardSeason();
   this.queryAwardData();
  },
  methods: {
    /**
     * 查询赛季
     */
    queryCupRewardSeason() {
      return new Promise((resolve, reject) => {
        const userInfoId = JSON.parse(localStorage.getItem("userInfoId"));
        const { campusId } = userInfoId;
        this.campusId = campusId;
        cupRewardSeason({
          param: {
            campusId
          }
        }).then(res => {
          if (res.code == 0) {
            this.otherSeasonData = res.data;
            this.otherSeasonData.map((item, index) => {
              item['name'] = item['seasonTagName'];
              if (index == 0) {
                this.currentSeasonLabel = item['seasonTagName'];
                this.selectSeasonTagId = item['seasonTagId'];
              }
            })
            resolve(this.otherSeasonData);
          } else {
            Toast(res.message);
          }
        })
      })
    },
    /**
     * 查询赛季奖励数据
     */
    queryAwardData() {
      cupRewardV2({
        param: {
          campusId: this.campusId,
          seasonTagId: this.selectSeasonTagId
        }
      }).then(res => {
        if(res.code == 0) {
          this.rewardList = res.data;
        } else {
          Toast(res.message);
        }
      })
    },
    onLoad() {

    },
    seasonChange(data) {
      this.currentSeasonLabel = data.item.name;
      this.selectSeasonTagId = data.item.seasonTagId;
      this.queryAwardData();
    },
  },
}
</script>

<style lang="less" scoped>
  .reward-distribution {
    .banner {
      img {
        width: 100%;
      }
    }
    .reward-body {
      .switch-season {
        width: 400px;
        margin: 28px 0 26px 48px;
        border: 2px solid #DCDCDD;
      }
      .reward-list {
        border-top: 2px solid #DEE5F0;
        .reward-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 48px;
        .left-warp {
          .reward-name {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 32px;
            color: #323232;
            line-height: 44px;
            text-align: left;
            font-style: normal;
          }
          .reward-time {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 28px;
            color: #68707D;
            line-height: 40px;
            text-align: left;
            font-style: normal;
          }
        }
        .right-wrap {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 48px;
          color: #EE4B4E;
          line-height: 66px;
          text-align: right;
          font-style: normal;
        }
      }
    }
    .empty-wrap {
      .empty-img {
        width: 386px;
        height: 244px;
        margin: 100px auto 0;
        background: url('../../assets/images/winterGame/empty_data.png') no-repeat center center;
        background-size: 100% 100%;
        display: block;
      }
      .empty-text {
        margin-top: 48px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 28px;
        color: #000000;
        line-height: 40px;
        text-align: center;
        font-style: normal;
      }
    }
  }
}
</style>